<template >
    <div persistent max-width="600px">
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card>
            <v-card-title class="headline"><v-icon color="blue">info</v-icon>Solicitar Mundança de Classe</v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field label="Nome do estudante" :disabled="true"
                                v-model="estudante.nome"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field label="Curso inscrito" :disabled="true"
                                v-model="estudante.descricao_curso"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field label="Classe Actual" persistent-hint :disabled="true"
                                v-model="estudante.classe"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select :items="Classes_filtradas" label="Selecione a Nova Classe"
                                v-model="classe_selecionada" @change="loadTurma()" required></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select :items="turmas_filtered" v-model="turma_selecionada" item-value="pkTurma"
                                item-text="turmadescricao" label="Selecione a nova Turma"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="12">
                            <v-text-field label="Porquê desejas fazer a mudança?" persistent-hint
                                v-model="motivo"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-text>
                <small>AnoLectivo( da ultima confirmação feita ):</small><strong>{{ estudante.anoLectivo }}</strong>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="fecharComponente">Cancelar</v-btn>
                <v-btn color="green darken-1" :disabled="estudante.nome === '' || estudante.descricao_curso === '' || estudante.classe === '' || classe_selecionada === '' || turma_selecionada === '' || motivo === ''" text @click="ConfirmarMudanca_classe()">Confirmar</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import _axios from '../../../../plugins/axios'
import Swal from 'sweetalert2';
const ls = require('local-storage')
export default {
    name: 'mudarClasseEst',
    props: ['estudante'],

    data: () => ({
        overlay: false,
        dialogo_classe: true,
        Classes_filtradas: [],
        turmasAll: [],
        classe_selecionada: '',
        classes: ['10ª Classe', '11ª Classe', '12ª Classe', '13ª Classe'],
        turma_selecionada: '',
        motivo: '',
        turmas_filtered: [],
        classe_id: 0
    }),

    created() {
        this.initializeturmasAll()
        this.ObterIdAnoLectivo()
        this.inicializar()
    },

    methods: {
        async initializeturmasAll() {
            try {
                this.overlay = true;
                this.turmasAll = await _axios.get('/turmaFindAll').then(res => res.data)
            } catch (error) {
                Swal.fire('Erro', 'Ocorreu um erro durante o carregamento das turmas!', 'error')
            } finally {
                this.overlay = false;
            }
        },

        async ObterIdAnoLectivo() {
            try {
                this.overlay = true;
                this.idanolectivo = await _axios.get('/ObterIdAnoLectivo/' + ls.get('anolectivo')).then(res => res.data)
            } catch (error) {
                Swal.fire('Erro', 'Ocorreu um erro durante o carregamento do ano lectivo!', 'error')
            } finally {
                this.overlay = false;
            }
        },

        inicializar() {
            this.Classes_filtradas = this.classes.filter(p => p !== this.estudante.classe)
        },

        loadTurma() {
            let valor = 0
            if (this.classe_selecionada === '10ª Classe') {
                valor = 1
            } else if (this.classe_selecionada === '11ª Classe') {
                valor = 2
            } else if (this.classe_selecionada === '12ª Classe') {
                valor = 3
            } else if (this.classe_selecionada === '13ª Classe') {
                valor = 4
            }
            this.turmas_filtered = this.turmasAll.filter(t => t.idCurso === this.estudante.idCurso && t.idAno_Academico === valor)
        },

        async ConfirmarMudanca_classe() {
            this.ObterIdClasse(this.classe_selecionada)
            let params = {
                nome: this.estudante.nome,
                idMudanca: 0,
                bi: this.estudante.bi,
                resultado: this.estudante.resultado,
                idAno_Academico: this.estudante.idAno_Academico,
                fkTurma: this.estudante.pkTurma,
                idCurso: this.estudante.idCurso,
                idMatricula: this.estudante.idMatricula,
                operacao: 1,
                fkTurma_novo: this.turma_selecionada,
                idanoacademico_novo: this.classe_id,
                descricao_operacao: 'Solicitacão de mundança de Classe',
                idCursoNovo: null,
                AutorAdmin: null,
                idanolectivo: this.idanolectivo[0].idAnoLectivo,
                fkPessoa: this.estudante.pkPessoa,
                idTurma: this.estudante.idTurma,
                mensagem_instituicao: this.motivo,
                mensagem_admin: null,
                ultimoanolectivo: this.estudante.anoLectivo,
                pkInscricao_na_turma: 0 //Significa que é um insert e não um update pkInscricao_na_turma=0;Quando update,o obtem o valor da view
            }

            try {
                this.overlay = true;
                let msg = await _axios.post('/mudancaInsertOrUpdate', params).then(res => res.data)
                if (msg.length) {
                    Swal.fire('Erro', 'Ocorreu um erro durante ao realizar essa operação!')
                } else {
                   Swal.fire('Sucesso', 'A sua solicitação de Mudança foi enviada ao Administrador , aguarde a confirmação', 'success')
                   this.fecharComponente()
                }
            } catch (error) {
                Swal.fire('Erro', 'Ocorreu um erro durante ao realizar essa operação!')
            } finally {
                this.overlay = false;
            }
        },

        ObterIdClasse(classe) {
            if (classe === '10ª Classe') { 
                this.classe_id = 1
             } else if (classe === '11ª Classe') { 
                this.classe_id = 2
             } else if (classe === '12ª Classe') {
                 this.classe_id = 3
             } else if (classe === '13ª Classe') { 
                this.classe_id = 4 
            }
        },

        fecharComponente() {
            this.Classes_filtradas = [];
            this.turmasAll = [];
            this.classe_selecionada = '';
            this.turma_selecionada = '';
            this.motivo = '';
            this.turmas_filtered = [];
            this.$emit('fecharComponente', false);
        }
    }
}
</script>
<style></style>